import React from 'react';
import { QueryClientProvider } from 'react-query';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import EHersEnrollmentSite from './EHersEnrollmentSite';
import theme from '../../theme';
import createReactQueryClient from '../../createReactQueryClient';
import { Microsites } from '../../../server/micrositeConstants';


const container = document.getElementById(Microsites.EHERS_ENROLLMENT);

const queryClient = createReactQueryClient();

if (container) {
  const root = createRoot(container);

  root.render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <EHersEnrollmentSite />
      </ThemeProvider>
    </QueryClientProvider>,
  );
} else {
  // eslint-disable-next-line no-console
  console.error(`${[Microsites.EHERS_ENROLLMENT]} container not found`);
}
